// State.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import IcdqModal from "../../AppComponents/icdqmodal/icdqmodal";

const State = () => {

  const screenfields = [
    {
      caption: "Code",
      field: "code",
      type: "text",
      required: true,
    }, 
    {
      caption: "Country",
      fieldtype: 'dropdown',
      field: "countryid",
      spacefield: 2,
      required: true,
      fieldwidth: 3,
      valuefield: 'id',
      displayfield: "country",
      endpoint: "countries",
    },
    {
      caption: "State",
      field: "state",
      spacefield: 2,
      type: "text",
      required: true,
      fieldwidth: 6,
  }
  ];

  const tableColumns = [
    { field: 'code', label: 'Code', width: 20 },
    { field: 'state', label: 'State', width: 100 },
    { field: 'country', label: 'Country', width: 100 },
  ];

  return (
        <IcdqModal title="State" GridWidth="45" FieldsArr={screenfields} controller="states" PrimaryKeyField='id' GridColumns={tableColumns}/>
  );
};

export default State;
